const container = document.querySelector('.falling-stars');

const starImages = [
  '/cdn/shop/files/star_3_1_x192.png',
  '/cdn/shop/files/star_3_2_x192.png',
  '/cdn/shop/files/star_3_3_x192.png',
  '/cdn/shop/files/star_3_4_x192.png',
  '/cdn/shop/files/star_3_5_x192.png'
];

let intervalTime = 2000; // PC用デフォルト
if (window.innerWidth < 768) {
  intervalTime = 3000; // スマホなら星を減らす
} else if (window.innerWidth < 1200) {
  intervalTime = 3000; // タブレットなら少し減らす
}

function createStar() {
  console.log('star');
  const star = document.createElement('div');
  star.classList.add('star');

  // ランダムで画像を選択
  const randomImg = starImages[Math.floor(Math.random() * starImages.length)];
  star.style.backgroundImage = `url(${randomImg})`;

  star.style.left = `${Math.random() * 100}vw`;
  star.style.animationDuration = `${Math.random() * 3 + 7}s`;

  // 最初の数個は delay なしにする
  if (performance.now() < 10000) { // ページ読み込みから10秒以内なら
    star.style.animationDelay = '0s';
  } else {
    star.style.animationDelay = `${Math.random() * 1}s`;
  }

  // ランダムに回転角度を設定
  const rotateAngle = Math.random() * 16 - 8; // -8〜+8度
  star.style.transform = `rotate(${rotateAngle}deg)`;
  
  container.appendChild(star);

  // 星が画面外に出たら削除
  setTimeout(() => {
    star.remove();
  }, 11000);
}

// 定期的に星を生成
setInterval(createStar, intervalTime);
